
enum EnumPlayStatus {
  None = 0,
  Started = 1,
  CompletedWithGetPrize = 2,
  CompletedWithoutGetPrize = 3,
}

export default class PlayStatus {

  constructor(
    private _status: EnumPlayStatus
  ) { }

  get isStarted(): boolean {
    return this._status === EnumPlayStatus.Started
  }

  get isCompletedWithGetPrize(): boolean {
    return this._status === EnumPlayStatus.CompletedWithGetPrize
  }

  get isCompletedWithoutGetPrize(): boolean {
    return this._status === EnumPlayStatus.CompletedWithoutGetPrize
  }

  get isCompleted(): boolean {
    return this.isCompletedWithGetPrize || this.isCompletedWithoutGetPrize
  }
}
